import type { AccountantShareDTO } from '@/features/accountant/api';

interface Props {
  shares: AccountantShareDTO[];
  isLoading?: boolean;
}

function formatMonth(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
}

export function HistoryList({ shares, isLoading }: Props) {
  if (isLoading) {
    return <p className="text-sm text-(--color-fg-muted)">Carregando histórico…</p>;
  }
  if (shares.length === 0) {
    return (
      <p className="text-sm text-(--color-fg-muted)">
        Nenhum envio ou acesso registrado ainda.
      </p>
    );
  }
  return (
    <ul className="flex flex-col divide-y divide-(--color-border)">
      {shares.map((s) => (
        <li key={s.id} className="flex items-center justify-between gap-3 py-2 text-sm">
          <div className="min-w-0">
            <p className="font-medium capitalize">{formatMonth(s.referenceMonth)}</p>
            <p className="text-xs text-(--color-fg-muted)">
              {s.channel === 'EMAIL_PACKAGE' ? 'Pacote por e-mail' : 'Acesso ao link'}
            </p>
          </div>
          <span className="text-xs tabular-nums text-(--color-fg-muted)">
            {new Date(s.sentAt).toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </li>
      ))}
    </ul>
  );
}
